import { appConfig } from '../../../../../config/customization';

const RADIO_SIZE = 14;
const INNER_RADIO_SIZE = 6;

export default {
  outerBorder: {
    height: RADIO_SIZE,
    width: RADIO_SIZE,
    borderRadius: RADIO_SIZE,
    borderStyle: 'solid',
    borderWidth: 2,
    overflow: 'hidden',
    borderColor: appConfig.colors.gray,
    alignItems: 'center',
    justifyContent: 'center',
    margin: '10px 10px 11px',
    flexShrink: 0
  },
  selected: {
    borderColor: appConfig.colors.primary
  },
  innerDot: {
    backgroundColor: appConfig.colors.primary,
    borderRadius: INNER_RADIO_SIZE,
    height: INNER_RADIO_SIZE,
    width: INNER_RADIO_SIZE
  },
  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 5
  },
  textContainer: {
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'left',
    width: '90%'
  },
  text: {
    width: '100%',
    fontSize: 14
  },
  subText: {
    color: appConfig.colors.lightGray
  }
};
